// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@conklin/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { requestRmaInformationStyles } from "@conklin/Overrides/Widgets/RequestRma/RequestRmaInformation";
import { color } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

requestRmaInformationStyles.fieldWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 33%;
        gap: 8px;

        @media print {
            display: block;
        }
    `,
};

requestRmaInformationStyles.orderNumberText =
    requestRmaInformationStyles.customerPOText =
    requestRmaInformationStyles.orderDateText =
        {
            ...xOrderInformationStyles.value,
        };

requestRmaInformationStyles.titleText = {
    ...xOrderInformationStyles.labelWithDots,
};

requestRmaInformationStyles.billingAddressText = {
    ...xOrderInformationStyles.address?.informationTitle,
};

requestRmaInformationStyles.wrapper = {
    css: css`
        display: flex;
        border-bottom: 1px solid ${color("common.border")};
        padding-bottom: 24px;
        gap: 20px 22px;
        margin-bottom: 24px;
    `,
};

requestRmaInformationStyles.billingWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        border-bottom: 1px solid ${color("common.border")};
        padding-bottom: 24px;
        margin-bottom: 24px;
    `,
};

requestRmaInformationStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};
